﻿import { IEmailEntity } from './email-entity';

export interface IEmailEntityRequest {
    emailTemplateId: number;
    entity: IEmailEntity;
}
